<template>
  <i :class="'icon-' + icon" class="p4a-icon"></i>
</template>

<script>
  export default {
    name: 'Icons',
    props: {
      icon: String
    }
  }
</script>

<style lang="scss" scoped>

  @font-face {
    font-family: "pro4all-icons";
    src:url("../fonts/pro4all-icons.eot");
    src:url("../fonts/pro4all-icons.eot?#iefix") format("embedded-opentype"),
    url("../fonts/pro4all-icons.woff") format("woff"),
    url("../fonts/pro4all-icons.ttf") format("truetype"),
    url("../fonts/pro4all-icons.svg#pro4all-icons") format("svg");
    font-weight: normal;
    font-style: normal;

  }

  [data-icon]:before {
    font-family: "pro4all-icons" !important;
    content: attr(data-icon);
    font-style: normal !important;
    font-weight: normal !important;
    font-variant: normal !important;
    text-transform: none !important;
    speak: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  [class^="icon-"]:before,
  [class*=" icon-"]:before {
    font-family: "pro4all-icons" !important;
    font-style: normal !important;
    font-weight: normal !important;
    font-variant: normal !important;
    text-transform: none !important;
    speak: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .icon-tbq-result-failed:before { content: "\e9f8"; }

  .icon-tbq-result-passed:before { content: "\e9f9"; }

  .icon-ls-schedules:before { content: "\e9f3"; }

  .icon-tbq-scan:before { content: "\e9f4"; }

  .icon-tbq-scan-add:before { content: "\e9f5"; }

  .icon-fire-alarm:before { content: "\e9f6"; }

  .icon-sprinkler:before { content: "\e9f7"; }

  .icon-floor-selector:before { content: "\e9f2"; }

  .icon-chevron-corner:before { content: "\e900"; }

  .icon-form-add-snag:before { content: "\e901"; }

  .icon-form-link-snag:before { content: "\e902"; }

  .icon-section-create:before { content: "\e903"; }

  .icon-section-remove-all:before { content: "\e904"; }

  .icon-section-flip:before { content: "\e905"; }

  .icon-perspective:before { content: "\e906"; }

  .icon-orthographic:before { content: "\e907"; }

  .icon-show-in-treeview:before { content: "\e908"; }

  .icon-building-selector:before { content: "\e909"; }

  .icon-show-all:before { content: "\e90a"; }

  .icon-isolate:before { content: "\e90b"; }

  .icon-view-card:before { content: "\e90c"; }

  .icon-knowledge:before { content: "\e90d"; }

  .icon-sns-type-logistics:before { content: "\e90e"; }

  .icon-sns-type-image:before { content: "\e90f"; }

  .icon-sns-type-cables:before { content: "\e910"; }

  .icon-sns-type-strange:before { content: "\e911"; }

  .icon-sns-type-warning:before { content: "\e912"; }

  .icon-sns-type-tweak:before { content: "\e913"; }

  .icon-sns-type-measure:before { content: "\e914"; }

  .icon-sns-type-walls:before { content: "\e915"; }

  .icon-sns-type-ventilation:before { content: "\e916"; }

  .icon-sns-type-liquids:before { content: "\e917"; }

  .icon-sns-type-finance:before { content: "\e918"; }

  .icon-sns-type-bolt:before { content: "\e919"; }

  .icon-sns-type-electricity:before { content: "\e91a"; }

  .icon-sns-type-fire:before { content: "\e91b"; }

  .icon-sns-type-quality:before { content: "\e91c"; }

  .icon-sns-type-object:before { content: "\e91d"; }

  .icon-sns-type-snag:before { content: "\e91e"; }

  .icon-sns-type-survey:before { content: "\e91f"; }

  .icon-boolean:before { content: "\e920"; }

  .icon-todo:before { content: "\e921"; }

  .icon-buttons:before { content: "\e922"; }

  .icon-status:before { content: "\e923"; }

  .icon-number:before { content: "\e924"; }

  .icon-description:before { content: "\e925"; }

  .icon-autograph:before { content: "\e926"; }

  .icon-priority:before { content: "\e927"; }

  .icon-accepted:before { content: "\e928"; }

  .icon-multiple-choice:before { content: "\e929"; }

  .icon-reports:before { content: "\e92a"; }

  .icon-item-location:before { content: "\e92b"; }

  .icon-item-add:before { content: "\e92c"; }

  .icon-placeholder:before { content: "\e92d"; }

  .icon-form-icon:before { content: "\e92e"; }

  .icon-snag-icon:before { content: "\e92f"; }

  .icon-drawing-move:before { content: "\e930"; }

  .icon-drawing-delete:before { content: "\e931"; }

  .icon-drawing-add:before { content: "\e932"; }

  .icon-drawing:before { content: "\e933"; }

  .icon-category-add:before { content: "\e934"; }

  .icon-category:before { content: "\e935"; }

  .icon-type-label-add:before { content: "\e936"; }

  .icon-type-label:before { content: "\e937"; }

  .icon-visit-move:before { content: "\e938"; }

  .icon-visit-delete:before { content: "\e939"; }

  .icon-visit-add:before { content: "\e93a"; }

  .icon-visit:before { content: "\e93b"; }

  .icon-synced-sns-project:before { content: "\e93c"; }

  .icon-sns-project-restore:before { content: "\e93d"; }

  .icon-sns-project-delete:before { content: "\e93e"; }

  .icon-sns-project-add:before { content: "\e93f"; }

  .icon-sns-project:before { content: "\e940"; }

  .icon-template:before { content: "\e941"; }

  .icon-section:before { content: "\e942"; }

  .icon-condition-add:before { content: "\e943"; }

  .icon-condition:before { content: "\e944"; }

  .icon-answer:before { content: "\e945"; }

  .icon-question:before { content: "\e946"; }

  .icon-ls-special-days:before { content: "\e947"; }

  .icon-ls-company-linked:before { content: "\e948"; }

  .icon-ls-company-edit:before { content: "\e949"; }

  .icon-ls-company-add:before { content: "\e94a"; }

  .icon-ls-company:before { content: "\e94b"; }

  .icon-ls-planning-edit:before { content: "\e94c"; }

  .icon-ls-planning-new:before { content: "\e94d"; }

  .icon-ls-planning:before { content: "\e94e"; }

  .icon-ls-projects:before { content: "\e94f"; }

  .icon-ls-project-edit:before { content: "\e950"; }

  .icon-ls-project-add:before { content: "\e951"; }

  .icon-ls-project:before { content: "\e952"; }

  .icon-ifclogo:before { content: "\e953"; }

  .icon-checkmark:before { content: "\e954"; }

  .icon-selection-center:before { content: "\e955"; }

  .icon-orbit:before { content: "\e956"; }

  .icon-object-center:before { content: "\e957"; }

  .icon-selection-transparant:before { content: "\e958"; }

  .icon-camera-pan:before { content: "\e959"; }

  .icon-ils:before { content: "\e95a"; }

  .icon-ifccolumn:before { content: "\e95b"; }

  .icon-ifcstairs:before { content: "\e95c"; }

  .icon-ifcbeam:before { content: "\e95d"; }

  .icon-ifcroof:before { content: "\e95e"; }

  .icon-ifcwindow:before { content: "\e95f"; }

  .icon-ifcdoor:before { content: "\e960"; }

  .icon-ifcwall:before { content: "\e961"; }

  .icon-hybrid:before { content: "\e962"; }

  .icon-blueprint:before { content: "\e963"; }

  .icon-three-dimensional:before { content: "\e964"; }

  .icon-mouse:before { content: "\e965"; }

  .icon-ifcbuildingstorey:before { content: "\e966"; }

  .icon-ifcbuilding:before { content: "\e967"; }

  .icon-ifcsite:before { content: "\e968"; }

  .icon-ifcobject:before { content: "\e969"; }

  .icon-ifcproject:before { content: "\e96a"; }

  .icon-ifcspace:before { content: "\e96b"; }

  .icon-map:before { content: "\e96c"; }

  .icon-permission:before { content: "\e96d"; }

  .icon-qr:before { content: "\e96e"; }

  .icon-stamp:before { content: "\e96f"; }

  .icon-unfreeze:before { content: "\e970"; }

  .icon-freeze:before { content: "\e971"; }

  .icon-as-logo:before { content: "\e972"; }

  .icon-ls-logo:before { content: "\e973"; }

  .icon-bms-logo:before { content: "\e974"; }

  .icon-sns-logo:before { content: "\e975"; }

  .icon-ds-logo:before { content: "\e976"; }

  .icon-portal-logo:before { content: "\e977"; }

  .icon-world:before { content: "\e978"; }

  .icon-pin:before { content: "\e979"; }

  .icon-column-add:before { content: "\e97a"; }

  .icon-disconnect:before { content: "\e97b"; }

  .icon-info:before { content: "\e97c"; }

  .icon-help:before { content: "\e97d"; }

  .icon-textarea:before { content: "\e97e"; }

  .icon-logout:before { content: "\e97f"; }

  .icon-send:before { content: "\e980"; }

  .icon-rotate-right:before { content: "\e981"; }

  .icon-rotate-left:before { content: "\e982"; }

  .icon-post-it:before { content: "\e983"; }

  .icon-toast:before { content: "\e984"; }

  .icon-grid-restore:before { content: "\e985"; }

  .icon-menu-collapse:before { content: "\e986"; }

  .icon-skip-year:before { content: "\e987"; }

  .icon-drag:before { content: "\e988"; }

  .icon-sync-failed:before { content: "\e989"; }

  .icon-sync-offline:before { content: "\e98a"; }

  .icon-sync-succes:before { content: "\e98b"; }

  .icon-test:before { content: "\e98c"; }

  .icon-save:before { content: "\e98d"; }

  .icon-helmet:before { content: "\e98e"; }

  .icon-city:before { content: "\e98f"; }

  .icon-adjust:before { content: "\e990"; }

  .icon-server-disconnected:before { content: "\e991"; }

  .icon-fullscreen:before { content: "\e992"; }

  .icon-image:before { content: "\e993"; }

  .icon-previous:before { content: "\e994"; }

  .icon-share:before { content: "\e995"; }

  .icon-collapse-small:before { content: "\e996"; }

  .icon-expand-small:before { content: "\e997"; }

  .icon-collapse:before { content: "\e998"; }

  .icon-expand:before { content: "\e999"; }

  .icon-treeview-chevron:before { content: "\e99a"; }

  .icon-options:before { content: "\e99b"; }

  .icon-time:before { content: "\e99c"; }

  .icon-password:before { content: "\e99d"; }

  .icon-close:before { content: "\e99e"; }

  .icon-undock:before { content: "\e99f"; }

  .icon-role-restore:before { content: "\e9a0"; }

  .icon-role-delete:before { content: "\e9a1"; }

  .icon-role-add:before { content: "\e9a2"; }

  .icon-role:before { content: "\e9a3"; }

  .icon-history:before { content: "\e9a4"; }

  .icon-refresh:before { content: "\e9a5"; }

  .icon-archive:before { content: "\e9a6"; }

  .icon-image-non:before { content: "\e9a7"; }

  .icon-photo-add:before { content: "\e9a8"; }

  .icon-photo:before { content: "\e9a9"; }

  .icon-touch:before { content: "\e9aa"; }

  .icon-hide:before { content: "\e9ab"; }

  .icon-view:before { content: "\e9ac"; }

  .icon-dashboard:before { content: "\e9ad"; }

  .icon-properties:before { content: "\e9ae"; }

  .icon-color-custom:before { content: "\e9af"; }

  .icon-color-pick:before { content: "\e9b0"; }

  .icon-select-small:before { content: "\e9b1"; }

  .icon-select-1:before { content: "\e9b2"; }

  .icon-sort-za:before { content: "\e9b3"; }

  .icon-sort-az:before { content: "\e9b4"; }

  .icon-input-empty:before { content: "\e9b5"; }

  .icon-state-error:before { content: "\e9b6"; }

  .icon-state-warning:before { content: "\e9b7"; }

  .icon-state-okay:before { content: "\e9b8"; }

  .icon-location:before { content: "\e9b9"; }

  .icon-view-column:before { content: "\e9ba"; }

  .icon-view-list:before { content: "\e9bb"; }

  .icon-chevron-small:before { content: "\e9bc"; }

  .icon-chevron:before { content: "\e9bd"; }

  .icon-date:before { content: "\e9be"; }

  .icon-comment-delete:before { content: "\e9bf"; }

  .icon-comment-add:before { content: "\e9c0"; }

  .icon-comment:before { content: "\e9c1"; }

  .icon-filter-delete:before { content: "\e9c2"; }

  .icon-filter:before { content: "\e9c3"; }

  .icon-page-not-found:before { content: "\e9c4"; }

  .icon-manage:before { content: "\e9c5"; }

  .icon-group-extern:before { content: "\e9c6"; }

  .icon-user-extern:before { content: "\e9c7"; }

  .icon-group:before { content: "\e9c8"; }

  .icon-user:before { content: "\e9c9"; }

  .icon-user-restore:before { content: "\e9ca"; }

  .icon-user-delete:before { content: "\e9cb"; }

  .icon-user-add:before { content: "\e9cc"; }

  .icon-account:before { content: "\e9cd"; }

  .icon-deselect:before { content: "\e9ce"; }

  .icon-select:before { content: "\e9cf"; }

  .icon-settings:before { content: "\e9d0"; }

  .icon-favorite-heart:before { content: "\e9d1"; }

  .icon-favorite:before { content: "\e9d2"; }

  .icon-notification:before { content: "\e9d3"; }

  .icon-network-add:before { content: "\e9d4"; }

  .icon-network-edit:before { content: "\e9d5"; }

  .icon-network:before { content: "\e9d6"; }

  .icon-procedure:before { content: "\e9d7"; }

  .icon-mail:before { content: "\e9d8"; }

  .icon-explorer:before { content: "\e9d9"; }

  .icon-unlocked:before { content: "\e9da"; }

  .icon-locked:before { content: "\e9db"; }

  .icon-upload:before { content: "\e9dc"; }

  .icon-download:before { content: "\e9dd"; }

  .icon-export:before { content: "\e9de"; }

  .icon-import:before { content: "\e9df"; }

  .icon-search:before { content: "\e9e0"; }

  .icon-readmark:before { content: "\e9e1"; }

  .icon-print:before { content: "\e9e2"; }

  .icon-approve:before { content: "\e9e3"; }

  .icon-block:before { content: "\e9e4"; }

  .icon-wait:before { content: "\e9e5"; }

  .icon-connect:before { content: "\e9e6"; }

  .icon-delete:before { content: "\e9e7"; }

  .icon-embed:before { content: "\e9e8"; }

  .icon-change:before { content: "\e9e9"; }

  .icon-duplicate:before { content: "\e9ea"; }

  .icon-copy:before { content: "\e9eb"; }

  .icon-cut:before { content: "\e9ec"; }

  .icon-folder-move:before { content: "\e9ed"; }

  .icon-folders:before { content: "\e9ee"; }

  .icon-folder:before { content: "\e9ef"; }

  .icon-open-file:before { content: "\e9f0"; }

  .icon-file:before { content: "\e9f1"; }

  .p4a-icon {

    &:before { font-size: inherit; }
  }

</style>



// WEBPACK FOOTER //
// node_modules/pro4all-ui/ui-kit/components/Icon.vue